<template>
  <a-layout :style="containerStyle">
    <a-layout-header v-if="hasLayout" class="header">
      <div class="logo-wrap" @click="goto('home')" />
      <div class="mid-wrap" />
      <div class="user-info-wrap">
        <div class="searchMenu" title="菜单搜索">
          <a-select
            v-if="isShow"
            ref="searchInput"
            v-model:value="searchValue"
            style="width: 200px;"
            :show-arrow="false"
            :filter-option="false"
            :default-active-first-option="false"
            not-found-content="暂无匹配的数据"
            :options="searchData"
            show-search
            placeholder="搜索菜单"
            :field-names="{ label: 'name', value: 'path' }"
            @search="debounceSearch"
            @change="handleChange"
            @blur="handleBlur"
            @focus="handleFocus"
          /><SearchOutlined :style="{fontSize: '20px', display: 'block', 'margin-left': '10px',cursor: 'pointer'}" @click="showSearch" />
        </div>
        <theme-config />

        <div class="notification-wrap" title="消息通知">
          <a-badge :count="count">
            <mail-outlined :style="{fontSize: '20px', display: 'block', cursor: 'pointer'}" @click="goto('notification')" />
          </a-badge>
        </div>
        <a-dropdown>
          <div class="avatar-wrap">
            <img class="avatar" :src="avatar">
            <div class="username">
              <span>{{ userInfo.name }}</span>
              <caret-down-outlined />
            </div>
          </div>

          <template #overlay>
            <a-menu :style="{width: '168px'}" theme="light">
              <a-menu-item @click="goto('personCenter')">个人中心</a-menu-item>
              <a-menu-item @click="handleLogout">退出登录</a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </a-layout-header>
    <a-layout :style="contentStyle">
      <a-layout-sider v-if="hasLayout" class="layout-sider" collapsible theme="light">
        <side-menu />
      </a-layout-sider>
      <a-layout class="layout-section">
        <!-- 面包屑区域 -->
        <!-- <breadcrumb /> -->
        <!-- 标签页面区域 -->
        <tabs-navigator v-if="hasLayout" />
        <a-layout-content
          class="layout-content"
        >
          <router-view v-slot="{ Component }">
            <keep-alive :exclude="noCacheRouteList">
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </a-layout-content>
      </a-layout>
    </a-layout>
    <div v-if="hasLayout" class="beian-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
        备案号：冀ICP备2026042644号-1
      </a>
    </div>
  </a-layout>
</template>
<script setup>
import { debounce } from 'lodash'
import { computed, onBeforeMount, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { getToken } from '@/utils/token'
import { getCount } from '@/api/sys/notificationApi'
// import Breadcrumb from '@/components/breadcrumb'
import TabsNavigator from '@/components/tabsNavigator/index.vue'
import SideMenu from '@/components/sideMenu/index.vue'
import themeConfig from '@/components/themeConfig'

const router = useRouter()
const hasLayout = computed(() => {
  return router.currentRoute.value.fullPath.indexOf('layout=0') === -1 && router.currentRoute.value.fullPath.indexOf('layout=blank') === -1
})
const store = useStore()
const containerStyle = {
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column'
}
const contentStyle = {
  flexGrow: '1'
}

const userInfo = computed(() => {
  return store.getters['user/basicInfo']
})

const user = store.getters['user/basicInfo']
const photoPath = ref(`/api/oss/v2/oss/filerecord/${user.photo}?isPreview=true&isPublic=false&access-token=${getToken()}`)
const avatar = computed(() => {
  return user.photo ? photoPath.value : `/img/avatar.png`
})

const noCacheRouteList = computed(() => {
  return store.getters['system/noCacheRouteList']
})

const count = computed(() => {
  return store.getters.notificationCount
})
// 菜单搜索
// 获取输入框的引用
const searchInput = ref(null)

const searchValue = ref(null)
const isShow = ref(false)
const searchData = ref([])
const showSearch = () => {
  isShow.value = !isShow.value
  if (isShow.value) {
    // 等待下一帧后设置焦点
    setTimeout(() => {
      searchInput.value.focus()
      searchValue.value = null
    }, 0)
  }
}
const handleBlur = () => {
  isShow.value = !isShow.value
}
const handleFocus = () => {
  getSearchData()
}
function searchByName(jsonData, searchTerm) {
  const results = []

  function searchChildren(data) {
    for (let i = 0; i < data.length; i++) {
      const node = data[i]

      if (node.children && node.children.length > 0) {
        searchChildren(node.children)
      }

      if (node.name.includes(searchTerm)) {
        results.push(node)
      }
    }
  }

  searchChildren(jsonData)

  return results
}
// 获取searchData
const getSearchData = () => {
  const allChildren = store.getters['user/visibleMenuList']
  function extractChildren(arr) {
    let childrenArray = []

    arr.forEach(obj => {
      childrenArray = childrenArray.concat(obj.children)
      if (obj.children) {
        childrenArray = childrenArray.concat(extractChildren(obj.children))
      }
    })

    return childrenArray
  }
  searchData.value = extractChildren(allChildren)
}
const handleSearch = (val) => {
  getSearchData()
  const searchResult = searchByName(searchData.value, val)
  searchData.value = searchResult
}
const debounceSearch = debounce(handleSearch, 500)
const handleChange = (node) => {
  if (!node) return
  router.push({ path: node })
}
// 获取消息通知个数
const getNoticationCount = () => {
  getCount().then(res => {
    if (!res.success) return
    store.commit('updateNotificationCount', res.data)
  })
}
getNoticationCount()
// 监听user对象中photo属性的变化，更新头像
watch(() => userInfo.value, (newVal) => {
  // 更新头像
  photoPath.value = newVal.photo ? `/api/oss/v2/oss/filerecord/${newVal.photo}?isPreview=true&isPublic=false&access-token=${getToken()}` : `/img/avatar.png`
}, { deep: true })
/**
 * 初始化应用状态
 */

onBeforeMount(() => {
  store.dispatch('user/updateUserInfo')
})

const goto = (name) => {
  router.push({ name })
}

/**
 * 退出登录
 */
const handleLogout = function () {
  store.dispatch('user/logout')
  router.push({ name: 'login' })
}
</script>

<style scoped lang="less">
@import "index.less";
.mixin();
</style>

